// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"122":"alerts","359":"schedules","771":"aichat","920":"library"}[chunkId] || chunkId) + "." + {"122":"32077f62","354":"41c77dcd","359":"c6f69182","427":"22201cff","557":"8aa0d335","771":"5d326083","785":"68ea4d66","920":"9f49e396"}[chunkId] + ".js";
};